module.exports = __webpack_public_path__ + "static/img/product4.d6017f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product4.png
// module id = lxln
// module chunks = 0